import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";

import Switch from "@mui/material/Switch";
import { useEffect, useMemo, useState } from "react";
import Header from "../../layout/Header";
import Sidebar from "../sidebar/Sidebar";

import {
  Autocomplete,
  Box,
  Button,
  Card,
  FormControlLabel,
  Input,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

import "../../assets/styles/pages.css";
import {
  service_getSetting,
  service_updateSetting,
} from "../../services/api.service";
import Swal from "sweetalert2";
import { check_role } from "../../controllers/helps.controller";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";

const Setting = () => {
  const [navstate, setNavstate] = useState(
    localStorage.getItem("nav-state") ?? true
  );
  const intl = useIntl();

  const site = localStorage.getItem("site-redeem");
  // generate code
  if (!check_role("superadmin")) {
    window.location.replace("/404");
  }
  const [portMemo_notice, setPortMemo_notice] = useState("");
  const [autoUsed, setAutoUsed] = useState(arrAutoUsed[0]);
  const [usedMin, setUsedMin] = useState(0);
  const [usedMax, setUsedMax] = useState(0);

  const [typePoint, setTypePoint] = useState(arrTypePoint[0]);
  const [pointStatic, setPointStatic] = useState(0);
  const [pointMin, setPointMin] = useState(0);
  const [pointMax, setPointMax] = useState(0);
  const [contentMess_freecode, setContentMess_freecode] = useState("");
  const [titleMess_freecode, setTitleMess_freecode] = useState("");
  const [report, setReport] = useState({});
  const [webstatus, setWebstatus] = useState(false);

  const [lamDung, setLamDung] = useState([]);

  // find code
  useEffect(() => {
    let handle = async () => {
      if (!localStorage.getItem("username-redeem")) {
        window.location.replace("/login");
      }
    };
    handle();
  }, []);
  useMemo(() => {
    const initData = async () => {
      const { result, status_code, valid } = await service_getSetting();
      if (valid && status_code === 200) {
        setPortMemo_notice(result?.portMemo_notice);
        setUsedMin(result?.usedMin ?? 0);
        setUsedMax(result?.usedMax ?? 0);
        setPointMax(result?.pointMax ?? 0);
        setPointMin(result?.pointMin ?? 0);
        setPointStatic(result?.pointStatic ?? 0);
        setContentMess_freecode(result?.contentMess_freecode ?? "");
        setTitleMess_freecode(result?.titleMess_freecode ?? "");
        setReport(result?.report ?? {});
        setWebstatus(result?.webstatus ?? false);
        arrAutoUsed.forEach((el) => {
          if (el.value === result?.autoUsed) setAutoUsed(el);
        });
        arrTypePoint.forEach((el) => {
          if (el.value === result?.typePoint) setTypePoint(el);
        });

        setLamDung(result?.lamDung ?? []);
      }
    };
    initData();
  }, []);
  const handelUplpadFile_setting = async () => {
    if (site === "bo_789bet") {
      const { statusCode, valid } = await service_updateSetting({
        site: site,
        portMemo_notice: portMemo_notice,
        contentMess_freecode: contentMess_freecode,
        titleMess_freecode: titleMess_freecode,
        autoUsed: autoUsed.value,
        usedMin: usedMin,
        usedMax: usedMax,
        typePoint: typePoint.value,
        pointMin: pointMin,
        pointMax: pointMax,
        pointStatic: pointStatic,
        report: report,
        webstatus: webstatus,
        lamDung: lamDung,
      });
      if (statusCode === 200 && valid) {
        Swal.fire({
          icon: "success",
          title: "Update thành công",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Update thất bại",
        });
      }
    } else {
      const { statusCode, valid } = await service_updateSetting({
        site: site,
        portMemo_notice: portMemo_notice,
        contentMess_freecode: contentMess_freecode,
        titleMess_freecode: titleMess_freecode,
        report: report,
        webstatus: webstatus,
        lamDung: lamDung,
      });
      if (statusCode === 200 && valid) {
        Swal.fire({
          icon: "success",
          title: "Update thành công",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Update thất bại",
        });
      }
    }
  };

  const handleEditLamDung = (lamDung, str) => {
    Swal.fire({
      icon: "warning",
      title: intl.formatMessage({ id: str }),
      showCancelButton: true,
      cancelButtonText: intl.formatMessage({ id: "cancel" }),
      confirmButtonText: intl.formatMessage({ id: "confirm" }),
      html: `
            <textarea id="edit-textArea" rows="12" cols="50" 
                style="width: 100%; padding: 4px 8px;" 
                placeholder="${intl.formatMessage({
                  id: "each_element_is_a_line",
                })}">
                ${lamDung ? lamDung.join("\n") : ""}
            </textarea>
        `,
      preConfirm: () => {
        let editTextArea = document.getElementById("edit-textArea").value;
        return editTextArea;
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        let textAreaArray = result.value
          .split("\n")
          .map((item) => item.trim())
          .filter((item) => item);
        setLamDung(textAreaArray);
      }
    });
  };

  return (
    <>
      <Sidebar setNavstate={setNavstate} navstate={navstate} />
      <Box id="main" className={navstate ? "" : "main-wide"}>
        <Header
          setNavstate={setNavstate}
          navstate={navstate}
          title={
            <FormattedMessage
              id="setting.header.title"
              defaultMessage="Cài đặt"
            />
          }
        />
        <Box className="input-form-cont">
          <Box className="title-find-code-table" sx={{ ml: 1, mt: 3, mb: 1 }}>
            <Typography variant="h6" className="title-text-table">
              <FormattedMessage
                id="setting.webstatus"
                defaultMessage="Trạng thái web nhận code:"
              />
            </Typography>
            <FormControlLabel
              label={
                webstatus ? (
                  <FormattedMessage
                    id="setting.status.active"
                    defaultMessage="Hoạt động"
                  />
                ) : (
                  <FormattedMessage
                    id="setting.status.maintenance"
                    defaultMessage="Bảo trì"
                  />
                )
              }
              labelPlacement="start"
              sx={{
                mx: 1,
                px: 1,
                border: 1,
                borderRadius: 1,
                color: webstatus ? "#00ff2f" : "#1d1d1d",
              }}
              control={
                <Switch
                  name="webstatus"
                  checked={webstatus ?? false}
                  onChange={(e) => setWebstatus(e.target.checked ?? false)}
                  inputProps={{ "aria-label": "controlled" }}
                  sx={{ color: webstatus ? "#00ff2f" : "#1d1d1d" }}
                />
              }
            />
          </Box>
          <Box className="title-find-code-table" sx={{ ml: 1, mt: 3, mb: 1 }}>
            <Typography variant="h6" className="title-text-table">
              <FormattedMessage
                id="setting.telegram.warning"
                defaultMessage="Cảnh báo Telegram:"
              />
            </Typography>
            <FormControlLabel
              label={
                <FormattedMessage
                  id="setting.telegram.createCode"
                  defaultMessage="Tạo code"
                />
              }
              labelPlacement="start"
              sx={{ mx: 1, px: 1, border: 1, borderRadius: 1 }}
              control={
                <Switch
                  name="random_code"
                  checked={report.random_code ?? false}
                  onChange={(e) =>
                    setReport({ ...report, [e.target.name]: e.target.checked })
                  }
                  inputProps={{ "aria-label": "controlled" }}
                />
              }
            />
            <FormControlLabel
              label={
                <FormattedMessage
                  id="setting.telegram.deleteCode"
                  defaultMessage="Xóa code"
                />
              }
              labelPlacement="start"
              sx={{ mx: 1, px: 1, border: 1, borderRadius: 1 }}
              control={
                <Switch
                  name="delete_code"
                  checked={report.delete_code ?? false}
                  onChange={(e) =>
                    setReport({ ...report, [e.target.name]: e.target.checked })
                  }
                  inputProps={{ "aria-label": "controlled" }}
                />
              }
            />
            <FormControlLabel
              label={
                <FormattedMessage
                  id="setting.telegram.downloadCode"
                  defaultMessage="Tải code"
                />
              }
              labelPlacement="start"
              sx={{ mx: 1, px: 1, border: 1, borderRadius: 1 }}
              control={
                <Switch
                  name="download_code"
                  checked={report.download_code ?? false}
                  onChange={(e) =>
                    setReport({ ...report, [e.target.name]: e.target.checked })
                  }
                  inputProps={{ "aria-label": "controlled" }}
                />
              }
            />
            <FormControlLabel
              label={
                <FormattedMessage
                  id="setting.telegram.findCode"
                  defaultMessage="Tìm code"
                />
              }
              labelPlacement="start"
              sx={{ mx: 1, px: 1, border: 1, borderRadius: 1 }}
              control={
                <Switch
                  name="find_code"
                  checked={report.find_code ?? false}
                  onChange={(e) =>
                    setReport({ ...report, [e.target.name]: e.target.checked })
                  }
                  inputProps={{ "aria-label": "controlled" }}
                />
              }
            />
            <FormControlLabel
              label={
                <FormattedMessage
                  id="setting.telegram.login"
                  defaultMessage="Đăng nhập"
                />
              }
              labelPlacement="start"
              sx={{ mx: 1, px: 1, border: 1, borderRadius: 1 }}
              control={
                <Switch
                  name="login_account"
                  checked={report.login_account ?? false}
                  onChange={(e) =>
                    setReport({ ...report, [e.target.name]: e.target.checked })
                  }
                  inputProps={{ "aria-label": "controlled" }}
                />
              }
            />
            <FormControlLabel
              label={
                <FormattedMessage
                  id="setting.telegram.whitelist"
                  defaultMessage="Whitelist"
                />
              }
              labelPlacement="start"
              sx={{ mx: 1, px: 1, border: 1, borderRadius: 1 }}
              control={
                <Switch
                  name="whitelist"
                  checked={report.whitelist ?? false}
                  onChange={(e) =>
                    setReport({ ...report, [e.target.name]: e.target.checked })
                  }
                  inputProps={{ "aria-label": "controlled" }}
                />
              }
            />
          </Box>
          <Box className="title-find-code-table">
            <Typography
              variant="h6"
              sx={{ ml: 1, mt: 3 }}
              className="title-text-table"
            >
              <FormattedMessage
                id="setting.message.customer"
                defaultMessage="Thông điệp gửi khách hàng khi cộng điểm"
              />
            </Typography>
          </Box>
          <Box className="input-form-wrapper">
            {/* Nội dung gửi khách hàng */}
            <TextField
              sx={{ margin: "5px" }}
              id="portMemo_notice"
              label={
                <FormattedMessage
                  id="setting.message.content"
                  defaultMessage="Nội dung gửi người chơi"
                />
              }
              title="Nội dung gửi người chơi"
              size="small"
              helperText="Liên Minh OKVIP - Công Ty Giải Trí 789BET phát thưởng thành công điểm thưởng CODELIVE"
              variant="standard"
              value={portMemo_notice}
              onChange={(event) => setPortMemo_notice(event.target.value)}
            />
          </Box>
          <Box className="title-find-code-table">
            <Typography
              variant="h6"
              sx={{ ml: 1, mt: 3 }}
              className="title-text-table"
            >
              <FormattedMessage
                id="setting.freecode.config"
                defaultMessage="Cấu hình gửi thư Freecode"
              />
            </Typography>
          </Box>
          <Box>
            <TextField
              sx={{ margin: "5px" }}
              id="titleMess_freecode"
              label={
                <FormattedMessage
                  id="setting.freecode.title"
                  defaultMessage="Tiêu đề gửi thư"
                />
              }
              title="Tiêu đề  gửi thư"
              size="small"
              helperText="CHÚC MỪNG QUÝ KHÁCH NHẬN ĐƯỢC CODE MAY MẮN"
              variant="standard"
              value={titleMess_freecode}
              onChange={(event) => {
                event.target.value.length > 49
                  ? setTitleMess_freecode(event.target.value.slice(0, 49))
                  : setTitleMess_freecode(event.target.value);
              }}
            />
            <TextField
              sx={{ margin: "5px" }}
              id="contentMess_freecode"
              label={
                <FormattedMessage
                  id="setting.freecode.content"
                  defaultMessage="Nội dung gửi thư"
                />
              }
              title="Nôi dung gửi thư"
              size="small"
              helperText="Liên minh OKVIP - Công ty Giải trí 789BET chúc mừng quý khách nhận được CODE miễn phí, chúc quý khách may mắn cược to thắng lớn!"
              variant="standard"
              value={contentMess_freecode}
              onChange={(event) => setContentMess_freecode(event.target.value)}
            />
          </Box>
          {site === "bo_789bet" && (
            <>
              <Box className="title-find-code-table">
                <Box className="mark"></Box>
                <p className="title-text-table">
                  <FormattedMessage
                    id="setting.auto.config"
                    defaultMessage="Cấu hình Auto thêm tài khoản nhận code"
                  />
                </p>
              </Box>
              <Box className="input-form-wrapper">
                {/* Trạng thái auto */}
                <Autocomplete
                  disablePortal
                  id="autoUsed"
                  options={arrAutoUsed}
                  sx={{ margin: "5px" }}
                  onChange={(event, value) => {
                    setAutoUsed(value);
                  }}
                  value={autoUsed}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <FormattedMessage
                          id="setting.auto.status"
                          defaultMessage="Trạng thái auto"
                        />
                      }
                      size="small"
                      title="Tự động thêm danh sách người nhận thưởng"
                      helperText="Thêm người nhận thưởng"
                      variant="standard"
                    />
                  )}
                />
                {autoUsed?.value === "auto" && (
                  <Box
                    sx={{
                      display: "flex",
                      width: "fit-content",
                      margin: "5px",
                    }}
                  >
                    <Box sx={{ display: "flex" }}>
                      <Typography sx={{ margin: "auto 5px" }}>
                        <FormattedMessage
                          id="setting.auto.from"
                          defaultMessage="Từ"
                        />
                      </Typography>
                      <Input
                        sx={{ width: "50px", margin: "auto" }}
                        type="number"
                        label="Số tài khoản"
                        variant="standard"
                        value={usedMin}
                        slotProps={{
                          input: {
                            min: 0,
                            max: 500,
                            step: 1,
                          },
                        }}
                        onChange={(event) =>
                          event.target.value < 0
                            ? setUsedMin(0)
                            : setUsedMin(parseInt(event.target.value))
                        }
                      />
                      <Typography sx={{ margin: "auto 5px" }}>
                        <FormattedMessage
                          id="setting.auto.to"
                          defaultMessage="Đến"
                        />
                      </Typography>
                      <Input
                        sx={{ width: "50px", margin: "auto" }}
                        type="number"
                        label="Đến"
                        variant="standard"
                        value={usedMax}
                        slotProps={{
                          input: {
                            min: 0,
                            max: 500,
                            step: 1,
                          },
                        }}
                        onChange={(event) =>
                          event.target.value < 0
                            ? setUsedMax(0)
                            : setUsedMax(parseInt(event.target.value))
                        }
                      />
                    </Box>
                  </Box>
                )}
                {/* Điểm thưởng */}
                {autoUsed?.value === "auto" && (
                  <Box
                    sx={{
                      display: "flex",
                      width: "fit-content",
                      margin: "5px",
                    }}
                  >
                    <Autocomplete
                      sx={{ width: "200px" }}
                      options={arrTypePoint}
                      id="disable-close-on-select"
                      defaultValue={arrTypePoint[0]}
                      disableClearable
                      renderInput={(params) => (
                        <TextField
                          sx={{ width: "100%" }}
                          {...params}
                          label={
                            <FormattedMessage
                              id="setting.auto.point"
                              defaultMessage="Điểm thưởng"
                            />
                          }
                          variant="standard"
                          helperText="Random điểm thưởng"
                        />
                      )}
                      title="Điểm thưởng tặng khách"
                      size="small"
                      value={typePoint}
                      onChange={(event, item) => {
                        setTypePoint(item);
                      }}
                    />
                    {typePoint?.value === "number_static" && (
                      <Box sx={{ display: "flex" }}>
                        <Typography sx={{ margin: "auto 5px" }}>
                          <FormattedMessage
                            id="setting.auto.pointStatic"
                            defaultMessage="Điểm"
                          />
                        </Typography>
                        <Input
                          sx={{ width: "50px", margin: "auto" }}
                          type="number"
                          label="Điểm"
                          variant="standard"
                          value={pointStatic}
                          slotProps={{
                            input: {
                              min: 0,
                              max: 500,
                              step: 1,
                            },
                          }}
                          onChange={(event) =>
                            event.target.value < 0
                              ? setPointStatic(0)
                              : setPointStatic(parseInt(event.target.value))
                          }
                        />
                      </Box>
                    )}
                    {(typePoint?.value === "number_range" ||
                      typePoint?.value === "number_or") && (
                      <Box sx={{ display: "flex" }}>
                        {typePoint?.value === "number_range" && (
                          <Typography sx={{ margin: "auto 5px" }}>
                            <FormattedMessage
                              id="setting.auto.pointFrom"
                              defaultMessage="Từ"
                            />
                          </Typography>
                        )}
                        {typePoint?.value === "number_or" && (
                          <Typography sx={{ margin: "auto 5px" }}>
                            <FormattedMessage
                              id="setting.auto.pointIs"
                              defaultMessage="Là"
                            />
                          </Typography>
                        )}
                        <Input
                          sx={{ width: "50px", margin: "auto" }}
                          type="number"
                          label="Điểm từ"
                          variant="standard"
                          value={pointMin}
                          slotProps={{
                            input: {
                              min: 0,
                              max: 500,
                              step: 1,
                            },
                          }}
                          onChange={(event) =>
                            event.target.value < 0
                              ? setPointMin(0)
                              : setPointMin(parseInt(event.target.value))
                          }
                        />
                        {typePoint?.value === "number_range" && (
                          <Typography sx={{ margin: "auto 5px" }}>
                            <FormattedMessage
                              id="setting.auto.pointTo"
                              defaultMessage="Đến"
                            />
                          </Typography>
                        )}
                        {typePoint?.value === "number_or" && (
                          <Typography sx={{ margin: "auto 5px" }}>
                            <FormattedMessage
                              id="setting.auto.pointOr"
                              defaultMessage="Hoặc"
                            />
                          </Typography>
                        )}
                        <Input
                          sx={{ width: "50px", margin: "auto" }}
                          type="number"
                          label="Đến"
                          variant="standard"
                          value={pointMax}
                          slotProps={{
                            input: {
                              min: 0,
                              max: 500,
                              step: 1,
                            },
                          }}
                          onChange={(event) =>
                            event.target.value < 0
                              ? setPointMax(0)
                              : setPointMax(parseInt(event.target.value))
                          }
                        />
                      </Box>
                    )}
                  </Box>
                )}
              </Box>
            </>
          )}

          <Stack
            direction={"row"}
            justifyContent={"flex-start"}
            alignItems={"center"}
            spacing={2}
            sx={{ mb: 2, mt: 2 }}
          >
            <Typography>
              <FormattedMessage
                id="update_abuse_group"
                defaultMessage="Nhóm lạm dụng"
              />
            </Typography>
            <Card
              className={""}
              sx={{ minWidth: 400, p: 1, cursor: "pointer" }}
              onClick={() => handleEditLamDung(lamDung, "update_abuse_group")}
            >
              {lamDung.map((item, index) => (
                <Typography key={index} fontSize={13} sx={{ letterSpacing: 1 }}>
                  {item}
                </Typography>
              ))}
            </Card>
          </Stack>

          <Button
            onClick={handelUplpadFile_setting}
            id="upload-btn"
            size="small"
            variant="outlined"
            sx={{
              m: "8px 8px 0 8px",
            }}
          >
            <FormattedMessage id="setting.save" defaultMessage="Lưu" />
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default Setting;

const arrTypePoint = [
  { value: "number_static", label: "Cố định" },
  { value: "number_range", label: "Khoảng từ A ~ B" },
  { value: "number_or", label: "Chọn A hoặc B" },
];

const arrAutoUsed = [
  { value: "auto", label: "Tự động" },
  { value: "stop", label: "Dừng" },
];
